<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Detailed Order Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Section</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="section" :items="section_list" item-text="name" item-value="id" label="section" outlined persistent-hint hint="Please Select section" @change="getMyOrders()" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Standard</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list" item-text="standard" item-value="id" label="Standard" outlined persistent-hint hint="Please Select Standard" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Division</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="division" :items="division_list" item-text="division" item-value="id" label="Division" outlined persistent-hint hint="Please Select Division" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Item Category</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="itemCategory" :items="itemCategory_list" item-text="name" item-value="id" label="Item Category" outlined persistent-hint hint="Please Select Item Category" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Item</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="item" :items="item_list" item-text="name" item-value="id" label="Item" outlined persistent-hint hint="Please Select Item" />
                </v-col>
            </v-row>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Size Label Type</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sizeLabelType" :items="sizeLabelTypeList" item-text="name" item-value="id" label="Size Label Type" outlined persistent-hint hint="Please Select Size Label Type" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Size Label</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sizeLabel" :items="sizeLableList" item-text="name" item-value="id" label="Size Label" outlined persistent-hint hint="Please Select Size Label" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Order Status</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="orderStatus" :items="orderStatusList" item-text="name" item-value="id" label="Order Status" outlined persistent-hint hint="Please Select Order Status" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Delivery Option</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="deliveryOption" :items="deliveryOptionList" item-text="name" item-value="id" label="Delivery Option" outlined persistent-hint hint="Please Select Delivery Option" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <p>
                        <v-icon color="error">*</v-icon><b>Supplier Shop</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="supplierShop" :items="supplierShopsList" item-text="name" item-value="id" label="Supplier Shop" outlined persistent-hint hint="Please Select Supplier Shop" />
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="4">
                    <v-radio-group v-model="filterType" row>
                        <v-radio label="All" value="all"></v-radio>
                        <v-radio label="Date Range" value="daterange"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row justify="center" v-if="filterType === 'daterange'">
                <v-col cols="12" sm="3">
                    <v-text-field label="From Date" rounded outlined dense type="date" v-model="fromDate"></v-text-field>
                </v-col>

                <v-col cols="12" sm="3">
                    <v-text-field label="To Date" rounded outlined dense type="date" v-model="toDate"></v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-btn color="primary" class="mt-4" @click="getMyOrders">Fetch</v-btn>
            </v-row>
        </v-card>

        <!-- <v-card class="box" v-if="query_list.length > 0">
       <v-data-table  :headers="headers" :items="query_list" >
          <template v-slot:top>
              <v-toolbar flat class="toolbar">
                  <v-toolbar-title>Queries</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical ></v-divider>
                  <v-spacer></v-spacer>
              </v-toolbar>
          </template>
       </v-data-table>
   </v-card> -->
    </v-container>
</div> <!-- /. root div -->
</template>

  
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        filterType: "all", // Default selection
        fromDate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        toDate: new Date().toISOString().slice(0, 10),
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        section_list: [],
        section: "",
        standard_list: [],
        standard: "",
        division_list: [],
        division: "",
        itemCategory_list: [],
        itemCategory: "",
        item_list: [],
        item: "",
        sizeLabelTypeList: [],
        sizeLabelType: "",
        sizeLableList: [],
        sizeLable: "",
        orderStatusList: [],
        orderStatus: "",
        deliveryOptionList: [],
        deliveryOption: "",
        supplierShopsList: [],
        supplierShop: "",
        headers: [{
                text: "Title",
                value: "title"
            },
            {
                text: "Description",
                value: "description"
            },
        ],
    }),
    methods: {
        getMyOrders() {
        let payload = {
            section: this.section || null,
            standard: this.standard || null,
            division: this.division || null,
            itemCategory: this.itemCategory || null,
            item: this.item || null,
            sizeLabelType: this.sizeLabelType || null,
            sizeLabel: this.sizeLabel || null,
            orderStatus: this.orderStatus || null,
            deliveryOption: this.deliveryOption || null,
            supplierShop: this.supplierShop || null,
            filterType: this.filterType,
            fromDate: this.filterType === "daterange" ? this.fromDate : null,
            toDate: this.filterType === "daterange" ? this.toDate : null,
        };

        axios.post("EduStore/getDetailedOrderReport", payload)
            .then((res) => {
                if (res.data.status === "success") {
                    this.query_list = res.data.orders;
                } else {
                    this.showSnackbar("#b71c1c", res.data.message);
                }
            })
            .catch(() => {
                this.showSnackbar("#b71c1c", "Failed to fetch data!");
            });
    },
        onLoad() {
            axios.post("EduStore/detailedOrderReportHome")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.section_list = res.data.section_list;
                        this.standard_list = res.data.standard_list;
                        this.division_list = res.data.division_list;
                        this.itemCategory_list = res.data.itemCategory_list;
                        this.item_list = res.data.item_list;
                        this.sizeLabelTypeList = res.data.sizeLabelTypeList;
                        this.sizeLableList = res.data.sizeLableList;
                        this.orderStatusList = res.data.orderStatusList;
                        this.deliveryOptionList = res.data.deliveryOptionList;
                        this.supplierShopsList = res.data.supplierShopsList;

                        // Set default selection to "All"
                        this.section = this.getDefaultValue(this.section_list);
                        this.standard = this.getDefaultValue(this.standard_list);
                        this.division = this.getDefaultValue(this.division_list);
                        this.itemCategory = this.getDefaultValue(this.itemCategory_list);
                        this.item = this.getDefaultValue(this.item_list);
                        this.sizeLabelType = this.getDefaultValue(this.sizeLabelTypeList);
                        this.sizeLable = this.getDefaultValue(this.sizeLableList);
                        this.orderStatus = this.getDefaultValue(this.orderStatusList);
                        this.deliveryOption = this.getDefaultValue(this.deliveryOptionList);
                        this.supplierShop = this.getDefaultValue(this.supplierShopsList);
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getDefaultValue(list) {
            return list.find(item => item.id === null) ? null : (list.length > 0 ? list[0].id : null);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
    },
    watch: {},
};
</script>
  
<style scoped>
  </style>
